import { LandslideIcon } from './LandslideIcon';

/**
 * author: Google
 * id AD048AA5-6C71-49DF-B5B2-427F634C3538
 * name landslide
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/landslide.svg
 * tags
 * - Nature 
 */
export const MudslideIcon = LandslideIcon;
export default MudslideIcon